export const OUTLOOK_WORKFLOW_STORAGE_TTL_MS = 4 * 60 * 60 * 1000;

export function isWorkflowStorageExpired(savedAt: number): boolean {
  return Date.now() - savedAt > OUTLOOK_WORKFLOW_STORAGE_TTL_MS;
}
